import React, {
  useState,
  useEffect,
  //  useMemo
} from 'react';
import { useSelector } from 'dva';
// import { channelMap } from '@/constants.js';
// import { optionToKey } from '@/utils/comUtil.js';
import MobileDatePicker from '@material-ui/lab/MobileDatePicker';
import TextField from '@material-ui/core/TextField';
import {
  sexMapList,
  maritalStatusList,
  industryList,
  professionalList,
} from '@/constants.js';
import Cascader from '@/components/cascader_ml/CascaderMl';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { Controller } from 'react-hook-form';
import { useLocation, useIntl } from 'umi';
// import DatePicker from '@material-ui/lab/DatePicker';

import { Box, Autocomplete } from '@material-ui/core';
import MemberDetailStyled from './MemberDetailStyled';

const MemberDetail = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { query } = location;
  const { opt } = query;
  const documentTypeList = [
    { id: '1', name: '身份证' },
    { id: '2', name: '其他' },
  ];
  // const intl = useIntl();
  //姓名
  const [name, setName] = useState('');
  //性别
  const [gender, setGender] = useState(null);
  //生日
  const [birthday, setBirthday] = useState('');
  //手机号
  const [mobile, setMobile] = useState('');
  //电子邮箱
  const [email, setEmail] = useState('');
  //婚姻状况
  const [maritalStatus, setMaritalStatus] = useState(null);
  //行业
  const [industry, setIndustry] = useState(null);
  //职业
  const [professional, setProfessional] = useState(null);
  //证件类型
  const [documentType, setDocumentType] = useState(null);
  //证件号码
  const [documentid, setDocumentid] = useState('');
  //鞋码
  // const [shoeSize, setShoeSize] = useState('');
  //省市区
  const [pca, setPca] = useState([]);
  //地址
  const [address, setAddress] = useState('');

  const { control, setValue, errors, setPcaInfo } = props;
  //关于邮箱和电话号码的校验
  // const [validate, setValidate] = useState({ email: false, idCard: false });

  // const loadingEffect = useSelector((state) => state.loading);
  // const loading = loadingEffect.effects['ml/getMemberDetail'];
  //获取会员详情
  const datas = useSelector((state) => state.adjustDetail.memberDetail);
  //初始给值
  useEffect(() => {
    if (datas) {
      let initialPca = [];
      let pcaInfo = {
        cityName: '',
        provinceName: '',
        countyName: '',
      };
      if (datas['provinceCode']) {
        initialPca.push(Number(datas['provinceCode']));
      }
      if (datas['provinceName']) {
        pcaInfo.provinceName = datas['provinceName'];
      }
      if (datas['cityName']) {
        pcaInfo.cityName = datas['cityName'];
      }
      if (datas['countyName']) {
        pcaInfo.countyName = datas['countyName'];
      }
      if (datas['cityCode']) {
        initialPca.push(Number(datas['cityCode']));
      }
      if (datas['countyCode']) {
        initialPca.push(Number(datas['countyCode']));
      }
      setName(datas.name);
      setValue('name', datas.name);
      const objGenderName = datas.gender;
      const value = sexMapList.find((i) => i.id === objGenderName);
      setGender(value);
      setValue('gender', datas.gender);
      setBirthday(datas.birthday);
      setValue('birthday', datas.birthday);
      setMobile(datas.mobile);
      setValue('mobile', datas.mobile);
      setValue('email', datas.email);
      setEmail(datas.email);
      // setShoeSize(datas.shoeSize);
      // setValue('shoeSize', datas.shoeSize);
      if (datas.industry) {
        setIndustry({ name: datas.industry });
        setValue('industry', datas.industry);
      }
      if (datas.professional) {
        setValue('professional', datas.professional);
        setProfessional({ name: datas.professional });
      }
      if (datas.maritalStatus) {
        setValue('maritalStatus', datas.maritalStatus);
        setMaritalStatus({ name: datas.maritalStatus });
      }
      if (initialPca.length > 0) {
        console.log(initialPca, 'initialPca');
        setPca(initialPca);
        setValue('pca', initialPca);
      }
      if (datas.documentType) {
        setDocumentType({ name: datas.documentType });
        setValue('documentType', datas.documentType);
      }
      setDocumentid(datas.documentid);
      setValue('documentid', datas.documentid);
      setAddress(datas.address);
      setValue('address', datas.address);
    }
  }, [datas, setValue]);
  //关于省市区
  const handleChangePca = (value, selectedItem) => {
    if (selectedItem) {
      const provinceName = selectedItem[0]?.label;
      const cityName = selectedItem[1]?.label;
      const countyName = selectedItem[2]?.label;
      setPcaInfo({
        provinceName,
        cityName,
        countyName,
      });
    } else {
      setPcaInfo({
        provinceName: '',
        cityName: '',
        countyName: '',
      });
    }

    // setValue('cityName', cityName);
    // setValue('countyName', countyName);
    setValue('pca', value);
    setPca(value);
  };
  console.log(documentType, 'documentType');
  return (
    <MemberDetailStyled>
      {/* <form onSubmit={handleSubmit(onFinish)}> */}
      <div className={'load'}>
        <Box container spacing={7} className="form-container">
          <Box className={'row'}>
            <Controller
              render={(rp) => (
                <TextField
                  disabled={opt === 'preview'}
                  value={name}
                  onChange={(e) => {
                    setValue('name', e.target.value);
                    setName(e.target.value);
                    return rp.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (!opt) {
                              setName('');
                              setValue('name', '');
                            }
                          }}
                          edge="end"
                        >
                          {name ? <ClearIcon className="clear-icon" /> : ''}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                  className="input"
                  label={formatMessage({ id: 'cm.member.detail.n01.lbl01' })}
                />
              )}
              name="name"
              control={control}
              id="basic"
            />
            <Controller
              name="gender"
              control={control}
              render={() => (
                <Autocomplete
                  disabled={opt === 'preview'}
                  id="clear-on-blur"
                  options={sexMapList}
                  name="gender"
                  onChange={(e, newValue) => {
                    setGender(newValue);
                    setValue('gender', newValue?.id);
                  }}
                  value={gender}
                  getOptionLabel={(option) => option.name}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({
                        id: 'cm.member.detail.n01.lbl02',
                      })}
                      variant="standard"
                    />
                  )}
                />
              )}
            />
            <Controller
              control={control}
              name="birthday"
              defaultValue={null}
              rules={{ required: true }}
              render={() => (
                <MobileDatePicker
                  inputFormat="yyyy/MM/dd"
                  clearable
                  okText={formatMessage({ id: 'comm.action.btn.07' })}
                  cancelText={formatMessage({ id: 'comm.action.btn.08' })}
                  clearText={formatMessage({ id: 'comm.action.btn.04' })}
                  value={birthday}
                  onChange={(e) => {
                    setValue('birthday', e);
                    setBirthday(e);
                  }}
                  renderInput={(prop) => (
                    <TextField
                      {...prop}
                      disabled={opt === 'preview'}
                      variant="standard"
                      error={Boolean(errors.birthday)}
                      helperText={Boolean(errors.birthday) && '请选择会员生日'}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="clear-btn"
                              onClick={() => {
                                if (!opt) {
                                  setBirthday(null);
                                  setValue('birthday', null);
                                }
                              }}
                              edge="end"
                            >
                              {birthday ? (
                                <ClearIcon className="clear-icon" />
                              ) : (
                                ''
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  label={formatMessage({ id: 'cm.member.detail.n03.lbl01' })}
                />
              )}
            />
            {/* <Controller
              control={control}
              rules={{
                required: true,
              }}
              error={Boolean(errors.birthday)}
              name="birthday"
              as={
                <DatePicker
                  inputFormat="yyyy/MM/dd"
                  value={birthday}
                  renderInput={(prop) => (
                    <TextField
                      {...prop}
                      variant="standard"
                      error={Boolean(errors.birthday)}
                      helperText={Boolean(errors.birthday) && '请选择会员生日'}
                    />
                  )}
                  label="生日"
                  onChange={(newValue) => {
                    setBirthday(newValue);
                    setValue('birthday', newValue);
                  }}
                />
              }
            /> */}
          </Box>
          <Box className="row">
            <Controller
              rules={{ required: true }}
              error={Boolean(errors.mobile)}
              helperText={Boolean(errors.mobile) && '请输入会员手机号'}
              render={(rp) => (
                <TextField
                  name="mobile"
                  variant="standard"
                  label={formatMessage({ id: 'cm.member.detail.n01.lbl04' })}
                  disabled={opt === 'preview'}
                  value={rp.value ?? mobile}
                  rules={{ required: true }}
                  error={Boolean(errors.mobile)}
                  helperText={Boolean(errors.mobile) && '请输入会员手机号'}
                  onChange={(e) => {
                    setMobile(e.target.value);
                    setValue('mobile', e.target.value);
                    return rp.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (opt !== 'preview') {
                              setMobile('');
                              setValue('mobile', '');
                            }
                          }}
                          edge="end"
                        >
                          {mobile ? <ClearIcon className="clear-icon" /> : ''}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              name="mobile"
              control={control}
              id="basic"
              label={formatMessage({ id: 'cm.member.detail.n01.lbl04' })}
            />
            <Controller
              render={(rp) => (
                <TextField
                  value={rp.value ?? email}
                  name="email"
                  label={formatMessage({ id: 'cm.member.detail.n03.lbl12' })}
                  disabled={opt === 'preview'}
                  control={control}
                  id="basic"
                  variant="standard"
                  className="input"
                  onChange={(e) => {
                    setValue('email', e.target.value);
                    setEmail(e.target.value);
                    return rp.value;
                  }}
                  s
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (opt !== 'preview') {
                              setEmail('');
                              setValue('email', '');
                            }
                          }}
                          edge="end"
                        >
                          {email ? <ClearIcon className="clear-icon" /> : ''}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              name="email"
              control={control}
              id="basic"
              variant="standard"
              className="input"
            />
            <Controller
              name="maritalStatus"
              control={control}
              render={() => (
                <Autocomplete
                  id="clear-on-blur"
                  disabled={opt === 'preview'}
                  options={maritalStatusList}
                  value={maritalStatus}
                  onChange={(e, newValue, type) => {
                    if (type === 'clear') {
                      setValue('maritalStatus', '');
                      setMaritalStatus({
                        name: '',
                      });
                    }
                    setValue('maritalStatus', newValue.name);
                    setMaritalStatus(newValue);
                  }}
                  name="maritalStatus"
                  getOptionLabel={(option) => option.name}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({
                        id: 'cm.member.detail.n03.lbl18',
                      })}
                      variant="standard"
                    />
                  )}
                />
              )}
            ></Controller>
          </Box>
          <Box className="row">
            <Controller
              control={control}
              name="industry"
              render={() => (
                <Autocomplete
                  disabled={opt === 'preview'}
                  id="clear-on-blur"
                  options={industryList}
                  value={industry}
                  onChange={(e, newValue, type) => {
                    if (type === 'clear') {
                      setValue('industry', '');
                      setIndustry({
                        name: '',
                      });
                    }
                    setValue('industry', newValue.name);
                    setIndustry(newValue);
                  }}
                  name="industry"
                  getOptionLabel={(option) => option.name}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({
                        id: 'cm.member.detail.n03.lbl13',
                      })}
                      variant="standard"
                    />
                  )}
                />
              )}
            ></Controller>
            <Controller
              name="professional"
              control={control}
              render={() => (
                <Autocomplete
                  id="clear-on-blur"
                  disabled={opt === 'preview'}
                  options={professionalList}
                  value={professional}
                  onChange={(e, newValue, type) => {
                    if (type === 'clear') {
                      setValue('professional', '');
                      setProfessional({
                        name: '',
                      });
                    }
                    setValue('professional', newValue.name);
                    setProfessional(newValue);
                  }}
                  name="professional"
                  getOptionLabel={(option) => option.name}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({
                        id: 'cm.member.detail.n03.lbl14',
                      })}
                      variant="standard"
                    />
                  )}
                />
              )}
            ></Controller>
            <Controller
              name="pca"
              control={control}
              as={
                <Cascader
                  label={formatMessage({ id: 'cm.member.detail.n03.lbl15' })}
                  // disabled={false}
                  disabled={opt === 'preview'}
                  handleChangePca={handleChangePca}
                  value={pca}
                  // value={['中国', 'zhejiang', 'hangzhou', 'West Lake']}
                />
              }
            />
          </Box>
          <Box className="row">
            <Controller
              render={(rp) => (
                <TextField
                  disabled={opt === 'preview'}
                  value={rp.value ?? address}
                  onChange={(e) => {
                    setValue('address', e.target.value);
                    setAddress(e.target.value);
                    return rp.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            if (opt !== 'preview') {
                              setValue('address', '');
                              setAddress('');
                            }
                          }}
                          edge="end"
                        >
                          {address ? <ClearIcon className="clear-icon" /> : ''}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  name="address"
                  id="basic"
                  variant="standard"
                  className="input"
                  label={formatMessage({ id: 'cm.member.detail.n03.lbl16' })}
                />
              )}
              name="address"
              control={control}
              id="basic"
              variant="standard"
              className="input"
              label={formatMessage({ id: 'cm.member.detail.n03.lbl16' })}
              defaultValue=""
            />
            <Controller
              name="documentType"
              control={control}
              render={() => (
                <Autocomplete
                  disabled={opt === 'preview'}
                  id="clear-on-blur"
                  options={documentTypeList}
                  name="documentType"
                  onChange={(e, newValue) => {
                    setDocumentType(newValue);
                    setValue('documentType', newValue?.id);
                  }}
                  value={documentType}
                  getOptionLabel={(option) => option.name}
                  clearOnBlur
                  renderInput={(param) => (
                    <TextField {...param} label="证件类型" variant="standard" />
                  )}
                />
              )}
            />
            <Box className="row">
              <Controller
                key={documentType?.id}
                render={(rp) => (
                  <TextField
                    disabled={opt === 'preview'}
                    value={rp.value ?? documentid}
                    error={Boolean(errors.documentid)}
                    helperText={
                      Boolean(errors.documentid) && '请输入正确的身份证号码'
                    }
                    onChange={(e) => {
                      setValue('documentid', e.target.value);
                      setDocumentid(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              if (opt !== 'preview') {
                                setValue('documentid', '');
                                setDocumentid('');
                              }
                            }}
                            edge="end"
                          >
                            {documentid ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    name="documentid"
                    id="basic"
                    variant="standard"
                    className="input"
                    label="证件号码"
                  />
                )}
                rules={
                  documentType?.id === '1'
                    ? {
                        pattern:
                          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      }
                    : {}
                }
                name="documentid"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="证件号码"
                defaultValue=""
              />
            </Box>
          </Box>
        </Box>

        {/* <Loading loading={loading || editLoading} className='load'> */}
        {/* <Box className="button-group">
            {editStatus ? (
              <>
                <Button
                  variant="contained"
                  type="submit"
                  fontsize="16px"
                  // onClick={() => {
                  //   onFinish();
                  // }}
                >
                  保存
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  fontsize="16px"
                  onClick={() => handleCancelClick()}
                >
                  取消
                </Button>
              </>
            ) : (
              <Button variant="contained" onClick={() => handleEditClick()}>
                编 辑
              </Button>
            )}
          </Box> */}
      </div>
      {/* </Loading> */}
      {/* </form> */}
    </MemberDetailStyled>
  );
};

export default MemberDetail;
